var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.16665V7.33331C5.5 4.29915 6.41667 1.83331 11 1.83331C15.5833 1.83331 16.5 4.29915 16.5 7.33331V9.16665",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 16.9583C12.2653 16.9583 13.2913 15.9323 13.2913 14.6667C13.2913 13.401 12.2653 12.375 10.9997 12.375C9.73402 12.375 8.70801 13.401 8.70801 14.6667C8.70801 15.9323 9.73402 16.9583 10.9997 16.9583Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.583 20.1667H6.41634C2.74967 20.1667 1.83301 19.25 1.83301 15.5834V13.75C1.83301 10.0834 2.74967 9.16669 6.41634 9.16669H15.583C19.2497 9.16669 20.1663 10.0834 20.1663 13.75V15.5834C20.1663 19.25 19.2497 20.1667 15.583 20.1667Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e18f38e9ab0524b5e383da08924c20ae.svg";
export { ForwardRef as ReactComponent };